import { Pipe, PipeTransform } from '@angular/core';
import { SLMovementLineOperation } from './movement';

@Pipe({ name: 'slmovementlineoperation' })
export class SLMovementLineOperationPipe implements PipeTransform {
 
  transform(value: SLMovementLineOperation, ...args: any[]) {
    if (value === 'CREDIT') {
      return 'Crédit';
    }
    else if(value === 'DEBIT') {
      return 'Débit';
    }
    else {
      return value;
    }
  }
}
